export default [
    {
        path: '/mcu',
        meta: {
            title: "Monthly Check Up",
            icon: "menu-logo.png",
            show: true
        },
        component: () => import(/* webpackChunkName: "mcu" */ '../views/admin/page/McuPage/Index'),
        redirect: { name: 'mcu.dashboard' },
        children: [
            {
                path: 'dashboard',
                name: 'mcu.dashboard',
                meta: {
                    title: "MCU Dashboard",
                    show: true
                },
                component: () => import(/* webpackChunkName: "mcu" */ '../views/admin/page/McuPage/McuDashboard'),
            },
            {
                path: 'mcu',
                name: 'mcu.mcu',
                meta: {
                    title: "Monthly Check Up",
                    show: true
                },
                component: () => import(/* webpackChunkName: "mcu" */ '../views/admin/page/McuPage/MonthlyCheckup'),
            },
            {
                path: 'form',
                name: 'mcu.form',
                meta: {
                    title: "MCU Form",
                    show: true
                },
                component: () => import(/* webpackChunkName: "mcu" */ '../views/admin/page/McuPage/McuForm'),
            }
        ]
    }
]